export default __webpack_public_path__ + "static/media/C6.503b5043.svg";